<template>
  <div class="updatePwd">
    <el-form label-width="100px">
      <el-form-item label="手机号：" class="inputborder">
        <el-input v-model="form.phonenumber"  placeholder="手机号"></el-input>
      </el-form-item>
      <el-form-item label="验证码：" class="inputborder">
        <el-input v-model="form.authCode" placeholder="验证码" style="width:130px;"></el-input>
        <el-button size="mini" @click="getcode">{{codemsg}}</el-button>
      </el-form-item>
      <el-form-item label="设置新密码：" class="inputborder">
        <el-input v-model="form.password" placeholder="新密码"></el-input>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'updatePwd',
  data() {
    return {
      form:{
        phonenumber:'',
        authCode:'',
        password:'',
      },
      canClick:true,
      times:60,
      codemsg:'获取验证码',
      interval:null,
    }
  },
  created(){
  },
  methods:{
    //获取验证码
    getcode(){
      if(!this.form.phonenumber){ this.$modal.msgError('请填写手机号');return;}
      if(!this.canClick){return;}
      this.HTTP.get(this.$api.sendAuthCode,{phone:this.form.phonenumber})
      .then((res={})=>{
        this.canClick = false;
        this.interval = setInterval(()=>{
          this.times--;
          this.codemsg = this.times+'S后重新发送';
          if(this.times==0){
            this.clearinfo();
          }
        },1000)
      })
    },
    clearinfo(){
      this.codemsg = '重新发送';
      if(this.interval!=''){
        clearInterval(this.interval);
      }
      this.canClick = true;
      this.times = 60;
    },
    postdata(){
      if(!this.form.authCode||!this.form.phonenumber||!this.form.password){this.$modal.msgError('请填写完整信息');return}
      this.HTTP.post(this.$api.user_updatePwd,this.form)
      .then((res={})=>{
        if(res.code==200){
          this.$modal.msgSuccess('修改成功')
          this.$emit('successpost')
        }
      })
    }
  }
}
</script>
<style lang='scss'>
.updatePwd{
  margin-top: 20px;
  .title{
    font-size: 23px;
    font-weight: bold;
    text-align: left;
    margin: 30px 0;
    line-height: 30px;
  }
  
}
.inputborder{
  border-bottom: 1px solid #ccc;
  input{
    border: none;
  }
  .el-form-item__label{
    height: 36px;
  }
  .el-form-item__content{
    line-height: 20px;
    input{
      height: 35px;
    }
  }
}

</style>